// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn_class[data-v-54a14f60] {\n  margin-left: 10px;\n}", ""]);
// Exports
module.exports = exports;
